import { Modal, Nav, Tab } from "react-bootstrap";
import { IClienteDadosUau } from "../../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SpinnerComponent from "../../../../Components/Loding/Spinner";
import { useEffect } from "react";
import InfoTelefone from "./InfoTelefone";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { BuscarClienteCompletoController } from "../../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import InfoBoleto from "./InfoBoleto";

interface InfoUauProps {
    ID_CHAVE_ERP: string;
}

export default function InfoUau(props: InfoUauProps) {
    const {
        value: clienteDadosUau,
        execute: buscarClienteCompleto,
        loading: clienteDadosUauLoading,
    } = useAsyncCallback(async (ID_CHAVE_ERP: string) => {
        let clienteDadosUauTemp: IClienteDadosUau = {
            VENDAS: undefined,
            PARCELAS_SERASA: [],
            USUARIO: [],
            TELEFONES: [],
            BOLETOS: [],
            HISTORICO: [],
            CLIENTES_VINCULADOS: [],
            DADOS_PROPONENTES: [],
        };
        await BuscarClienteCompletoController(ID_CHAVE_ERP).then(
            (res: IClienteDadosUau[]) => {
                clienteDadosUauTemp = res[0];
                return clienteDadosUauTemp;
            }
        );
        return clienteDadosUauTemp;
    }, []);
    useEffect(() => {
        buscarClienteCompleto(props.ID_CHAVE_ERP);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {!clienteDadosUauLoading ? (
                <>
                    <Tab.Container defaultActiveKey={"boletos"}>
                        <Modal.Header className="flex-wrap">
                            <Modal.Title className="card-title d-flex flex-row flex-nowrap">
                                <FontAwesomeIcon
                                    icon={faInfo}
                                    className="mr-2"
                                />
                                <h3 className="card-label">Informarções UAU</h3>
                            </Modal.Title>
                            <div className="card-toolbar">
                                <Nav
                                    variant="tabs"
                                    role="tablist"
                                    className="nav-tabs nav-bold nav-tabs-line"
                                >
                                    {/* <Nav.Item>
                                        <Nav.Link eventKey="unidade">
                                            <span className="nav-text">
                                                Unidade
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="historico">
                                            <span className="nav-text">
                                                Histórico de Atendimento
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="atendimentos">
                                            <span className="nav-text">
                                                Atendimentos
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="parcelas">
                                            <span className="nav-text">
                                                Parcelas no SPC/Serasa
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item> */}
                                    <Nav.Item>
                                        <Nav.Link eventKey="boletos">
                                            <span className="nav-text">
                                                Boletos
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="telefone">
                                            <span className="nav-text">
                                                {"Telefone(s)"}
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* <Nav.Item>
                                        <Nav.Link eventKey="manutencoes">
                                            <span className="nav-text">
                                                Manutenções
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="dependentes">
                                            <span className="nav-text">
                                                Dependentes
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item> */}
                                </Nav>
                            </div>
                        </Modal.Header>

                        <Modal.Body>
                            <Tab.Content>
                                {/* <Tab.Pane eventKey="unidade">
                                    <>
                                        <InfoUnidade
                                            clienteDados={clienteDadosUau}
                                        />
                                    </>
                                </Tab.Pane>
                                <Tab.Pane eventKey="historico">
                                    <></>
                                </Tab.Pane>
                                <Tab.Pane eventKey="atendimentos">
                                    <></>
                                </Tab.Pane>
                                <Tab.Pane eventKey="parcelas">
                                    <>
                                        <InfoParcela
                                            clienteDados={clienteDadosUau}
                                        />
                                    </>
                                </Tab.Pane> */}
                                <Tab.Pane eventKey="boletos">
                                    <>
                                        <InfoBoleto
                                            clienteDados={clienteDadosUau}
                                        />
                                    </>
                                </Tab.Pane>
                                <Tab.Pane eventKey="telefone">
                                    <>
                                        <InfoTelefone
                                            clienteDados={clienteDadosUau}
                                        />
                                    </>
                                </Tab.Pane>
                                {/* <Tab.Pane eventKey="manutencoes">
                                    <></>
                                </Tab.Pane>
                                <Tab.Pane eventKey="dependentes">
                                    <></>
                                </Tab.Pane> */}
                            </Tab.Content>
                        </Modal.Body>
                    </Tab.Container>
                </>
            ) : (
                <SpinnerComponent />
            )}
        </>
    );
}
